var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBezel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1885_1451",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 71,
    width: 237,
    height: 115
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246 71.5537H9.91113V185.033H246V71.5537Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1885_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.44 145.501L236.706 145.839H236.761C239.21 145.839 241.492 144.883 243.273 143.139C245.054 141.396 246 139.034 246 136.56V125.201C246 120.084 241.882 115.922 236.817 115.922L180.828 115.585",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.638 145.501L19.2055 145.839H19.1499C16.7011 145.839 14.4192 144.883 12.6382 143.139C10.9129 141.396 9.91113 139.034 9.91113 136.56V125.201C9.91113 120.084 14.0296 115.922 19.0942 115.922L74.2484 115.585",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7063 128.238C81.7063 153.543 102.243 174.068 127.399 174.181H127.566C152.833 174.181 173.37 153.599 173.37 128.238C173.37 102.876 152.833 82.3511 127.566 82.3511C102.299 82.3511 81.762 102.876 81.762 128.238H81.7063ZM84.4334 128.294C84.4334 104.451 103.746 85.1065 127.566 85.1065C151.386 85.1065 170.699 104.451 170.699 128.294C170.699 152.137 151.386 171.482 127.566 171.482C103.746 171.482 84.4334 152.137 84.4334 128.294Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.566 174.349H127.288C102.076 174.124 81.5948 153.486 81.5948 128.237C81.5948 102.989 102.187 82.2383 127.566 82.2383C152.945 82.2383 173.537 102.932 173.537 128.294C173.537 153.655 152.889 174.349 127.566 174.349ZM127.566 174.068C152.778 174.068 173.259 153.543 173.259 128.294C173.259 103.045 152.722 82.5195 127.566 82.5195C102.41 82.5195 81.8731 103.045 81.8731 128.237C81.8731 153.43 102.299 173.899 127.399 174.012H127.566V174.068ZM127.566 171.65C103.69 171.65 84.3219 152.193 84.3219 128.294C84.3219 104.394 103.746 84.9375 127.566 84.9375C151.386 84.9375 170.81 104.394 170.81 128.294C170.81 152.193 151.386 171.65 127.566 171.65ZM127.566 85.2187C103.857 85.2187 84.6002 104.507 84.6002 128.294C84.6002 152.081 103.857 171.369 127.566 171.369C151.275 171.369 170.532 152.081 170.532 128.294C170.532 104.507 151.275 85.2187 127.566 85.2187Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.623 160.403H95.453V96.0718H159.623V160.403ZM98.4584 157.367H156.674V99.1084H98.4584V157.367Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.51 173.73L82.1515 128.293L127.51 82.8003L172.869 128.237L127.51 173.674V173.73ZM86.3813 128.237L127.51 169.456L168.639 128.237L127.51 87.0178L86.3813 128.237Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1318 128.238C71.1318 159.391 96.3992 184.696 127.399 184.809L127.566 184.865C158.733 184.865 184 159.504 184 128.294C184 97.0841 158.677 71.7227 127.566 71.7227C96.4548 71.7227 71.1318 97.0278 71.1318 128.238ZM82.2628 128.294C82.2628 98.9398 110.09 82.8007 127.399 82.8007C143.483 82.8007 171.311 98.9398 171.311 128.294C171.311 157.648 149.049 172.775 127.566 172.775C96.1766 172.775 82.2628 144.658 82.2628 128.294Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.566 185.033H127.176C96.1209 184.752 70.9091 159.335 70.9091 128.237C70.9091 97.1401 96.3435 71.5537 127.566 71.5537C158.788 71.5537 184.167 97.0276 184.167 128.294C184.167 159.56 158.788 185.033 127.566 185.033ZM127.566 184.64C158.566 184.64 183.833 159.335 183.833 128.294C183.833 97.2525 158.566 71.9473 127.566 71.9473C96.5661 71.9473 71.2987 97.1963 71.2987 128.237C71.2987 159.278 96.4548 184.527 127.343 184.584H127.51L127.566 184.64Z",
    fill: "#343334"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBezel);
export default __webpack_public_path__ + "static/media/Bezel.0834cd53e90d5f35048d7ffda1ef943e.svg";
export { ForwardRef as ReactComponent };